// Renders a single animation preview card
export function createCard(animation, onHoverPlay) {
  const card = document.createElement('div');
  card.className = 'explore-card';
  card.dataset.id = animation.id;

  // Thumbnail display
  const display = document.createElement('div');
  display.className = 'card-display';
  display.style.color = animation.thumbnail_color || '#ca4b15';
  // Fit the preview to the card: monospace char width ≈ 0.6em; the display
  // has ~160px of usable width (200px min card − 40px padding). Shrink the
  // font for wide grids so they don't overflow and get center-clipped.
  const cols = animation.thumbnail_cols || 9;
  const rows = animation.thumbnail_rows || 3;
  const fitFontSize = Math.max(
    6,
    Math.min(14, Math.floor(160 / (cols * 0.6)), Math.floor(80 / (rows * 1.1)))
  );
  display.style.fontSize = fitFontSize + 'px';
  if (animation.thumbnail_text) {
    display.textContent = animation.thumbnail_text;
  } else {
    display.textContent = '(no preview)';
    display.style.color = '#557';
    display.style.fontSize = '12px';
  }
  card.appendChild(display);

  // Info section
  const info = document.createElement('div');
  info.className = 'card-info';

  const title = document.createElement('div');
  title.className = 'card-title';
  title.textContent = animation.title || 'Untitled';
  info.appendChild(title);

  const author = document.createElement('div');
  author.className = 'card-author';
  author.textContent = animation.display_name || 'Anonymous';
  info.appendChild(author);

  card.appendChild(info);

  // Hover animation
  let hoverTimer = null;
  let animating = false;
  let cleanup = null;

  card.addEventListener('mouseenter', () => {
    if (onHoverPlay) {
      cleanup = onHoverPlay(animation.id, display);
      animating = true;
    }
  });

  card.addEventListener('mouseleave', () => {
    if (cleanup) { cleanup(); cleanup = null; }
    animating = false;
    // Reset to static thumbnail
    display.innerHTML = '';
    display.style.color = animation.thumbnail_color || '#ca4b15';
    display.textContent = animation.thumbnail_text || '(no preview)';
  });

  // Click to view
  card.addEventListener('click', () => {
    window.location.hash = '/view/' + animation.id;
  });

  return card;
}
